module.exports = __webpack_public_path__ + "static/img/success.fa6f2c6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success.gif
// module id = Ldry
// module chunks = 2